export function usePolling(key) {
    const storageKey = `poll_remaining_${key}`;
    function poll(options) {
        if (options.remaining <= 0) {
            localStorage.removeItem(storageKey);
            options.onFinish();
            return;
        }
        localStorage.setItem(storageKey, String(options.remaining));
        setTimeout(() => {
            options.fetch(() => {
                options.onPoll();
                if (options.shouldStop()) {
                    localStorage.removeItem(storageKey);
                    options.onFinish();
                    return;
                }
                poll({ ...options, remaining: options.remaining - 1 });
            });
        }, options.interval);
    }
    function getPollRemaining() {
        const val = localStorage.getItem(storageKey);
        return val ? parseInt(val) : null;
    }
    return { poll, getPollRemaining };
}
